import * as React from 'react';
import { TStockItem } from 'api/stock/stock.types';

type TProductPageProps = Record<string, never>;

export type TProductPage = React.FC<TProductPageProps>;

/** Which product-type view to render on the product page (extend when adding routes) */
export type TProductPageKind = 'phoneCase';

export type TVariationStockEntry = {
  id: string;
  quantity: number;
};

/** Per phone model → per variation → stock row id + quantity */
export type TVariationsStockByPhone = Record<
  string,
  Record<string, TVariationStockEntry>
>;

export type TPhoneCasesAvailability = {
  phoneModelsList: string[];
  variationsList: string[];
  variationsStock: TVariationsStockByPhone;
};

export function buildPhoneCasesAvailability(
  items: TStockItem[] | undefined
): TPhoneCasesAvailability {
  if (!items?.length) {
    return {
      phoneModelsList: [],
      variationsList: [],
      variationsStock: {},
    };
  }
  const variationsStock = items.reduce<TVariationsStockByPhone>((acc, item) => {
    const modelName = item.name;
    const variationKey = item.variation ?? '';

    if (!acc[modelName]) {
      acc[modelName] = {};
    }
    acc[modelName][variationKey] = {
      id: item.id,
      quantity: item.quantity,
    };
    return acc;
  }, {});
  console.log(variationsStock);
  const phoneModelsList = Array.from(new Set(items.map((i) => i.name))).sort();
  const variationsList = Array.from(
    new Set(items.map((i) => i.variation ?? ''))
  ).sort();
  console.log(variationsList);
  return {
    phoneModelsList,
    variationsList,
    variationsStock,
  };
}
